import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as SenderIDService from 'services/messaging/sender-id';

export const useSenderIDService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchSenderIds = async (options = {}) => {
    const { error, payload } = await SenderIDService.read({ ...options, token });
    if (error) {
      return {
        sender_ids: [],
        size: 0
      };
    }

    const {
      data: sender_ids,
      meta: { size }
    } = payload;
    return { sender_ids, size };
  };

  const createSenderId = async (options = {}) => {
    const { error, payload } = await SenderIDService.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to submit request. Please try again.');
    } else {
      toast.success('Request submitted successfully.');
    }

    return payload;
  };

  const searchSenderId = async (keys, keyword, options = {}) => {
    const { error, payload } = await SenderIDService.search(keys, keyword, { ...options, token });
    if (error) {
      return { sender_ids: [], size: 0 };
    }

    const {
      data: sender_ids,
      meta: { size }
    } = payload;
    return { sender_ids, size };
  };

  return { fetchSenderIds, createSenderId, searchSenderId };
};
